import { createActions } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions({
    // view warehouse
    requestViewWarehouse: ['id'],
    viewWarehouseSucceeded: ['data'],
    viewWarehouseFailed: ['error'],

    // clear state
    clearWarehouseViewState: null,
});

export default {
    // view warehouse
    [types.REQUEST_VIEW_WAREHOUSE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            loading: true,
            error: null,
        },
    }),
    [types.VIEW_WAREHOUSE_SUCCEEDED]: (state, { data }) => ({
        ...state,
        view: {
            ...state.view,
            warehouseDetails: data,
            loading: false,
        },
    }),
    [types.VIEW_WAREHOUSE_FAILED]: (state, { error }) => ({
        ...state,
        view: {
            ...state.view,
            loading: false,
            error,
        },
    }),

    // clear state
    [types.CLEAR_WAREHOUSE_VIEW_STATE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            warehouseDetails: null,
        },
    }),
}
